import { render, staticRenderFns } from "./SummaryHeader.vue?vue&type=template&id=37e13dde&scoped=true"
import script from "./SummaryHeader.vue?vue&type=script&lang=js"
export * from "./SummaryHeader.vue?vue&type=script&lang=js"
import style0 from "./SummaryHeader.vue?vue&type=style&index=0&id=37e13dde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e13dde",
  null
  
)

export default component.exports